/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SharePromptResponse } from '../../models/share-prompt-response';

export interface PromptsPromptIdSharePost$Params {
  promptId: string;
}

export function promptsPromptIdSharePost(
  http: HttpClient,
  rootUrl: string,
  params: PromptsPromptIdSharePost$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<SharePromptResponse>> {
  const rb = new RequestBuilder(rootUrl, promptsPromptIdSharePost.PATH, 'post');
  if (params) {
    rb.path('promptId', params.promptId, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharePromptResponse>;
      }),
    );
}

promptsPromptIdSharePost.PATH = '/prompts/{promptId}/share';
